import { Box, Button, TextField } from "@mui/material";
import IEslTemplateItem from "../../../../models/esl/eslTemplateElement";
import { useTranslation } from "react-i18next";
import { ChangeEvent } from "react";

interface IImageElementPropretiesProps {
  selectedElement: IEslTemplateItem;
  onUpdateElement: (element: IEslTemplateItem) => void;
}

const ImageElementPropreties = ({ selectedElement, onUpdateElement }: IImageElementPropretiesProps) => {
  const { t } = useTranslation(['eslTemplate', 'common']);

  const onImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files || !files.length) return;

    onUpdateElement({ ...selectedElement, imageSrc: URL.createObjectURL(files[0]), imageFile: files[0] });
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
      <input
        accept="image/*"
        style={{ display: 'none' }}
        id="upload-button-file"
        type="file"
        onChange={onImageUpload}
      />
      <label htmlFor="upload-button-file">
        <Button variant="contained" color="primary" component="span">
          {t('eslTemplate:templateEditor.elementPropreties.uploadImage')}
        </Button>
      </label>
    </Box>
  )
}

export default ImageElementPropreties;